<template>
  <div class="modal-processing-indicator">
    <slot>Please wait while we process your request ...</slot>
  </div>
</template>

<script>
export default {
  name: 'modal-processing-indicator',
};
</script>

<style lang="scss" scoped>
.modal-processing-indicator {
    float:left;
    width:100%;
    font-size:24px;
    padding: 5px 0;
}
</style>
